import {FontAwesomeIcon, PageHeader, Button} from "~/components";
import AiGenerator from "../components/AiGenerator";

/**
 * Màn AI SEO ĐỘC LẬP (`/ai`): sinh nội dung ad-hoc, không gắn dự án (project_id=0).
 * Bản gắn dự án (có trợ lý phân tích dữ liệu) là `features/AiTool/pages/AiProjectHome.js`.
 */
function AiTool() {
	return (
		<div className="container">
			<PageHeader
				icon="fa-light fa-wand-magic-sparkles"
				title="AI SEO"
				subtitle="Sinh nội dung SEO bằng AI: meta title/description, câu hỏi thường gặp, dàn ý bài viết."
				actions={
					<Button to="/ai/history" white
						leftIcon={<FontAwesomeIcon icon="fa-light fa-clock-rotate-left" />}>
						Lịch sử
					</Button>
				}
			/>

			<AiGenerator projectId={0} />
		</div>
	);
}

export default AiTool;
